document.addEventListener('DOMContentLoaded', function() {
    scrollObserve('.js-fadein');
});
function scrollObserve(val) {
    const els = document.querySelectorAll(val);
    const cb = function(entries, observer) {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                entry.target.classList.add('is-active');
                observer.unobserve(entry.target); //1回で処理を停止
            } else {
                entry.target.classList.remove('is-active');
            }
        });
    }

    const io = new IntersectionObserver(cb);
    els.forEach(el => io.observe(el));
}

// TOPメインビジュアルSwiper
(function(container) {
    if (!container) return;
    
    new Swiper(container, {
        pagination: {
            el: container.querySelector('.swiper-pagination'),
        },
        loop: true,
        effect: 'fade',
        autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        },
        speed: 2000,
    });
})(document.querySelector('.p-top-mv__swiper'));

// TOP先輩の声Swiper
(function(container) {
    if (!container) return;
    
    new Swiper(container, {
        pagination: {
            el: container.querySelector('.swiper-pagination'),
            clickable: true
        },
        speed: 1000,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
            960: {
                slidesPerView: 1.5,
                spaceBetween: 40,
                centeredSlides: true
            }
        }
    });
})(document.querySelector('.p-top-interview__swiper'));

// コース紹介用Swiper
courseSwiper(document.querySelector('.advancedSwiper2'), document.querySelector('.advancedSwiper'));
courseSwiper(document.querySelector('.sportsSwiper2'), document.querySelector('.sportsSwiper'));
courseSwiper(document.querySelector('.generalSwiper2'), document.querySelector('.generalSwiper'));
function courseSwiper(container, container2) {    
    let thumbSwiper = new Swiper(container, {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            960: {
                spaceBetween: 25,
            },
        }
    });

    let mainSwiper = new Swiper(container2, {
        spaceBetween: 10,
        thumbs: {
            swiper: thumbSwiper,
        }
    });
}

// 学校行事用Swiper
function eventSwiper(container, container2) {    
    if (!container) return;
    if (!container2) return;

    let thumbSwiper = new Swiper(container, {
        centeredSlides: true,
        centeredSlidesBounds: true, 
        direction: "horizontal",
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        breakpoints: {
            960: {
                direction: "vertical",
            }
        }
    });

    let mainSwiper = new Swiper(container2, {
        direction: "horizontal",
        spaceBetween: 10,
        thumbs: {
            swiper: thumbSwiper,
        }
    });
}
eventSwiper(document.querySelector('[data-swiper="2"]'), document.querySelector('[data-swiper="1"]'));
eventSwiper(document.querySelector('[data-swiper="4"]'), document.querySelector('[data-swiper="3"]'));
eventSwiper(document.querySelector('[data-swiper="6"]'), document.querySelector('[data-swiper="5"]'));
eventSwiper(document.querySelector('[data-swiper="8"]'), document.querySelector('[data-swiper="7"]'));
eventSwiper(document.querySelector('[data-swiper="10"]'), document.querySelector('[data-swiper="9"]'));
eventSwiper(document.querySelector('[data-swiper="12"]'), document.querySelector('[data-swiper="11"]'));
eventSwiper(document.querySelector('[data-swiper="14"]'), document.querySelector('[data-swiper="13"]'));
eventSwiper(document.querySelector('[data-swiper="16"]'), document.querySelector('[data-swiper="15"]'));
eventSwiper(document.querySelector('[data-swiper="18"]'), document.querySelector('[data-swiper="17"]'));
eventSwiper(document.querySelector('[data-swiper="20"]'), document.querySelector('[data-swiper="19"]'));

// TOPに戻るボタン
let scroll = new SmoothScroll('a[href*="#"]', {
    speedAsDuration: true,
    speed: 1000,
    easing: 'easeInOutQuint'
})